import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cad247c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "is-size-5 has-text-centered" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "is-size-5 has-text-centered" }

import Thumbnail from '@/components/common/Thumbnail.vue'
import { computed } from 'vue'
import { customDownload } from '@/helpers/customDownload'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadViewer',
  setup(__props) {

const store = useStore()
const content = computed(() => store.state.content)

const entityType = computed(() => content.value?.mediaType || content.value?.entityType)
const isWidget = store.getters['widgets/isWidget']

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(isWidget))
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(customDownload)(content.value?.contentUrl)))
        }, [
          _createVNode(Thumbnail, {
            class: "is-128x128",
            "data-int": "download-thumbnail",
            "thumbnail-type": entityType.value,
            "thumbnail-url": content.value.thumbnailUrl
          }, null, 8, ["thumbnail-type", "thumbnail-url"]),
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('clickToDownload')), 1)
        ]))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          download: "",
          href: content.value?.contentUrl
        }, [
          _createVNode(Thumbnail, {
            class: "is-128x128",
            "data-int": "download-thumbnail",
            "thumbnail-type": entityType.value,
            "thumbnail-url": content.value.thumbnailUrl
          }, null, 8, ["thumbnail-type", "thumbnail-url"]),
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('clickToDownload')), 1)
        ], 8, _hoisted_3))
  ]))
}
}

})